
define('CustomStockMessage.EntryPoint',
	[
		'CustomStockMessage.View',
		'Facets.ItemCell.View',
		'underscore'
	],
	function (
		CustomStockMessageView,
		FacetsItemCellView,
		_

	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {
				var layout = container.getComponent('Layout');
				if (layout) {
					layout.addChildView('Quantity.Pricing', function () {
						return new CustomStockMessageView({ container: container });
					});

					var environment = container.getComponent('Environment');
					if (environment) {
						var customStockMessageConfig = environment.getConfig('CustomStockMessage');
						var isUpperCase = customStockMessageConfig.isUpperCase;
						this.textToShow = isUpperCase ? customStockMessageConfig.textToShow.toUpperCase() : customStockMessageConfig.textToShow;
						this.linkToOpen = customStockMessageConfig.linkToOpen;

						var self = this;
						layout.addToViewContextDefinition('Facets.ItemCell.View', 'textToShow', 'string', function (context) {
							return self.textToShow;
						});

						layout.addToViewContextDefinition('Facets.ItemCell.View', 'linkToOpen', 'string', function (context) {
							return self.linkToOpen;
						});

						layout.addToViewContextDefinition('Facets.ItemCell.View', 'showCustomStockMessage', 'boolean', function (context) {
							var actualItemId = context.itemId;
							var plp = container.getComponent('PLP');
							if(plp){
								var itemsInfo = plp.getItemsInfo();
								var itemInformation = _.filter(itemsInfo, {internalid: actualItemId});

								if(itemInformation){
									var itemInfo = itemInformation[0];
									var isCoreRequired = itemInfo.custitem_jc_corerequired;
									var containOnStoreDisplay = itemInfo.storedisplayname2 ? itemInfo.storedisplayname2.indexOf("MUST HAVE CORE") != -1 ? true : false : false;
									return isCoreRequired || containOnStoreDisplay;
								}else{
									return false;
								}
							}else{
								return false;
							}
						});

						layout.addToViewContextDefinition('Facets.ItemCell.View', 'stockMessage', 'string', function (context) {
							var actualItemId = context.itemId;
							var plp = container.getComponent('PLP');
							if(plp){
								var itemsInfo = plp.getItemsInfo();
								var itemInformation = _.filter(itemsInfo, {internalid: actualItemId});

								if(itemInformation){
									var itemInfo = itemInformation[0];
									var isCoreRequired = itemInfo.custitem_jc_corerequired;
									var containOnStoreDisplay = itemInfo.storedisplayname2 ? itemInfo.storedisplayname2.indexOf("MUST HAVE CORE") != -1 ? true : false : false;
									if(isCoreRequired || containOnStoreDisplay){
										return ''
									}else{
										return context.stockMessage;
									}
								}
							}
							return '';
						});
					}
				}



			}
		};
	});
